<template>
	<div class="printlabel">
		<div :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
			<el-row style="margin-top:20px">
				<el-col :span="9" style="color:transparent">
					1
				</el-col>
				<el-col :span="5">
					<el-radio-group v-model="type" @input="selecttype">
					  <el-radio :label="item.value" v-for="(item,index) in typelist" :key="index">{{item.name}}</el-radio>
					</el-radio-group>
				</el-col>
			</el-row>
			<el-row style="margin-top:20px">
				<el-col :span="3" style="color:transparent">
					1
				</el-col>
				<el-col :span="16">
					<div v-if="type==0">
						<el-card class="box-card" style="text-align: center;" shadow="never">
							<el-form>
								<div class="inputBox" style="width:100%">
									<el-form-item class="inputItem col8" v-for="(item,index) in inputlist" :label="'内容'+item.index" :key="index" label-width="80px" size="mini">
										<el-input v-model="item.value" :ref="'input_'+index" style="width:200px" @keyup.native="val => enterinput(val, index)"></el-input>
									</el-form-item>
								</div>
							</el-form>
						</el-card>
					</div>
					<div v-if="type==1">
					   <el-card class="box-card" style="text-align: center;" shadow="never">
						<div slot="header" class="clearfix" style="text-align: left;">
							<span>选择文件</span>
							<span @click="downmode" style="color:#0066CC;text-decoration: underline;cursor:pointer;">(导入模板)</span>
						</div>
						<el-upload
							name="fileupload"
							drag
							:action="fileurl"
							:multiple="false"
							:limit="1"
							accept=".xlsx,.xls"
							auto-upload
							:on-success="UploadSuccess"
							:on-error="UploadError"
							:on-change="UploadChange"
							:show-file-list="false"
							ref="upload"
							:file-list="filelist"
							:before-upload="UploadBefore"
						>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">
								将文件拖到此处，或
								<em>点击上传</em>
								<br />
								( 支持 .xlsx .xls 文件 )
							</div>
						</el-upload>
						<div style="width:100%;text-align:center;">{{ filename }}</div>
					   </el-card>
					</div>
				</el-col>
			</el-row>
			<el-row class="footerhandler_print">
				<el-col :span="6" class="submitBtn_switch" style="text-align: right;color:transparent">1</el-col>
				<el-col :span="4" class="submitBtn"><div @click="startprint">确定</div></el-col>
				<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">取消</div></el-col>
			</el-row>
		</div>
		<printhandler ref="printhandler"></printhandler>
	</div>	
</template>

<script>
import Utils from '../../lib/util.js';
import printhandler from '@/components/order/printhandler_check.vue';
export default {
	components: {
		printhandler
	},
data() {
		return {
			typelist:[{value:0,name:'手动填写'},{value:1,name:'文件导入'}],
			type:0,
			inputlist:[{index:1,value:''},{index:2,value:''},{index:3,value:''},{index:4,value:''},
			{index:5,value:''},{index:6,value:''},{index:7,value:''},{index:8,value:''},
			{index:9,value:''},{index:10,value:''},{index:11,value:''},{index:12,value:''},{index:13,value:''},{index:14,value:''},{index:15,value:''},{index:16,value:''},
			{index:17,value:''},{index:18,value:''},{index:19,value:''},
			{index:20,value:''},{index:21,value:''},{index:22,value:''},{index:23,value:''},{index:24,value:''},{index:25,value:''},{index:26,value:''},{index:27,value:''},{index:28,value:''},{index:29,value:''},{index:30,value:''}],
			divclass:'printlabel',
			downpath: localStorage.getItem('c_folder') + '/导入模版.zip', //导入模板路径
			fileurl:'',
			mode: '', //业务模块名称
			uploadfileurl: '', //上传之后保存下来的临时文件路径
			filename: '',
			tid: '',
			filelist: [],
			windowHeight: window.innerHeight - 150,
			batch:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/packagemanager/printlabel.scss');
		});
	},
	methods: {
		downmode(){
			//debugger
			this.$tool.DownFileByurl(this.$apiprototype.modeSever+'/'+this.downpath,'导入模板.zip');
		},
		selecttype(e){
			if(e==1){
				this.fileurl =
					this.$apiprototype.ApiServer +
					'/Order/checkexcelfile?domain=' +
					this.$apiprototype.WebServer+ '&mode=&modetype=';
			}
		},
		enterinput(event, index) {
			var control='';
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					control='input_'+(index+1);
					if(this.$refs[control][0]!=undefined)
						this.$refs[control][0].focus();
				} else if (event.keyCode == 37) {
					control='input_'+(index-1);
					if(this.$refs[control][0]!=undefined)
						this.$refs[control][0].focus();
				}
			}
		},
		UploadSuccess(res, file, fileList) {
			this.$tool.loadingclose();
			if (res.state == '1') {
				this.uploadfileurl = res.fileurl;
				this.filename = res.filename;
				this.tid = res.tid;
			} else {
				this.filename = '';
				this.$tool.message(res.message, 0);
			}
			this.$refs.upload.clearFiles();
		},
		UploadError(err, file, fileList) {
			debugger
			//console.log('上传错误 error', err);
		},
		UploadChange(file, fileList) {
			if (fileList.length > 0) this.$tool.loading('正在检测文件',this.divclass);
		},
		UploadBefore(file){
			
		},
		startprint(){
			//如果是导入的就先导入，再打印
			//如果是手填的，先保存，再导入
			if(this.type==0)
				this.saveinput();
			else if(this.type==1)
				this.saveimport();			
		},
		cancel(){
			this.$emit('cancel');
		},
		saveinput(){
			var that=this;
			var list=this.inputlist.filter(function(e){return e.value=='';});
			if(list.length==this.inputlist.length){
				this.$tool.message('请填写打印内容', 0);
				return false;
			}
			this.$apipost.post.SaveInput({paraminfo:this.inputlist}).then(res => {
				if (res.state=='1') {
					that.batch=res.batch;
					that.goprint();
				}else
					this.$tool.message(res.message, 0);
			});
		},
		saveimport(){
			var that = this;
			var error = '';
			var inportinfo = new Object();
			inportinfo.fileurl = this.uploadfileurl;
			inportinfo.tid = this.tid;
			if (inportinfo.fileurl == '' || inportinfo.fileurl == undefined) {
				this.$tool.message('请上传文件', 0);
				inportinfo='';
				return false;
			} 
			if (inportinfo != '') {
				this.$tool.loading('正在导入', this.divclass);
				this.$apipost.post.SaveInport({ inportinfo: JSON.stringify(inportinfo) }).then(res => {
					this.$tool.loadingclose();
					that.uploadfileurl='';
					that.tid='';
					that.filename='';
					that.filelist=[];
					if (res.state=='1') {
						that.batch=res.batch;
						that.goprint();
					} else {
						this.$tool.message('导入异常，请重试', 0);
					}
				});
			}
		},
		goprint(){
			var that=this;
			this.$apipost.post.SaveDataTemptoExcelTemp({ batch:this.batch }).then(res => {
				if (res.state=='1') {
					this.$tool.loading('正在打印', this.divclass);
					if (this.$refs.printhandler != undefined) {
						this.$refs.printhandler.init({
							pageparam: that._data,
							isgrid: false,
							pkval: '',
							searchinfo:'',
							funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
							handtype: 13, 
							isrollback: false,
							parentpage: that,
							isprint: 1,
							batch: that.batch,
							sys:'自定义标签'
						});
					}
				} else {
					this.$tool.loadingclose();
					this.$tool.message('打印异常，请重试', 0);
				}
			});
		}
	}
}
</script>

<style>
</style>
